import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  showMore: 'Show {numberOfAccounts} more',
  showLess: 'Show less',
})
